import React, { Component } from "react";
import "./style.css";
import './plugin';

export default class loading extends Component {
  render() {
    return (
      <div className="view">
        <div className="spinner"></div>
      </div>
    );
  }
}
